import styled from 'styled-components';
import { media, Column } from '@simplywallst/ui-core';
import { SubSubSectionHeader } from '@/pages/CompanyReport/components/Overview/components/SubSubSectionHeader';

export const ColumnWithMargin = styled(Column)`
  ${media.smDown`
     margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

export const Header = styled(SubSubSectionHeader)`
  margin-bottom: ${({ theme }) => theme.x2spacePx + 4}px;
`;
